import { HttpParams } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-getting-there',
  templateUrl: './getting-there.component.html',
  styleUrls: ['./getting-there.component.scss'],
})

export class GettingThereComponent implements OnInit {
  @Input()
  jobAddress?: JobAddress;

  constructor() { }

  ngOnInit() { }

  onGetDirections() {
    const params = new HttpParams()
      .set('api', '1')
      .set('destination', `${this.jobAddress.addressLine1}, ${this.jobAddress.addressLine2}`);
    window.open(`https://www.google.com/maps/dir/?${params.toString()}`);
  }
}
export interface JobAddress {
  addressLine1: string;
  addressLine2: string;
}
